import { Col, Divider, Row } from 'antd';
import React from 'react';
import CfopRelatedToEntry from './CfopRelatedToEntry';
import InputCstForNcm from './InputCstForNcm';
import { useWindowSize } from '@/hooks';

interface Props {
  hasOutputCfopOnImportPurchase?: boolean;
}

const ConfirmNcmAndCfopForm = ({ hasOutputCfopOnImportPurchase }: Props) => {
  const { width } = useWindowSize();
  return (
    <Row gutter={[24, 24]}>
      <Col span={24} xxl={10}>
        <CfopRelatedToEntry
          hasOutputCfopOnImportPurchase={hasOutputCfopOnImportPurchase}
        />
      </Col>

      <Col span={width <= 1536 ? 24 : undefined}>
        <Divider
          type={width <= 1536 ? 'horizontal' : 'vertical'}
          style={{ minHeight: '100%', maxWidth: '100%', margin: 0 }}
        />
      </Col>

      <Col span={24} xxl={13}>
        <InputCstForNcm />
      </Col>
    </Row>
  );
};

export default ConfirmNcmAndCfopForm;
